import Layout from '@/components/layout/Layout';

const Piskotki = () => {
  return (
    <Layout
      title="Politika piškotkov | Lux Decor by Kamen"
      description="Informacije o tem, kako Lux Decor by Kamen uporablja piškotke za izboljšanje uporabniške izkušnje na naši spletni strani."
    >
      <section className="py-16 bg-luxbeige">
        <div className="container mx-auto px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-semibold mb-6">Politika piškotkov</h1>
            <div className="h-1 w-24 bg-luxgold mb-10"></div>
            
            <div className="lux-card space-y-6">
              <section>
                <h2 className="text-2xl font-medium mb-4">1. Kaj so piškotki?</h2>
                <p className="text-luxgray">
                  Piškotki so majhne besedilne datoteke, ki se shranijo na vašo napravo (računalnik, tablico, telefon) ob obisku spletne strani.
                  Piškotki omogočajo spletni strani, da si zapomni vaše dejanja in nastavitve v določenem časovnem obdobju, 
                  kar pomeni, da vam ni treba ponovno vnašati informacij vsakič, ko obiščete stran ali brskate z ene strani na drugo.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">2. Vrste piškotkov, ki jih uporabljamo</h2>
                <p className="text-luxgray">
                  Na naši spletni strani uporabljamo naslednje vrste piškotkov:
                </p>
                
                <h3 className="text-xl font-medium mt-4 mb-2">Nujno potrebni piškotki</h3>
                <p className="text-luxgray">
                  Ti piškotki so bistveni za delovanje spletne strani in jih ni mogoče izklopiti v naših sistemih. 
                  Običajno se nastavijo samo kot odziv na dejanja, ki jih izvajate in ki predstavljajo zahtevo po storitvah, 
                  kot je nastavitev nastavitev zasebnosti, prijava ali izpolnjevanje obrazcev.
                </p>
                
                <h3 className="text-xl font-medium mt-4 mb-2">Analitični piškotki</h3>
                <p className="text-luxgray">
                  Ti piškotki nam omogočajo štetje obiskov in virov prometa, da lahko merimo in izboljšamo delovanje naše spletne strani. 
                  Pomagajo nam ugotoviti, katere strani so najbolj in najmanj priljubljene, in videti, kako se obiskovalci premikajo po strani.
                </p>
                
                <h3 className="text-xl font-medium mt-4 mb-2">Funkcionalni piškotki</h3>
                <p className="text-luxgray">
                  Ti piškotki omogočajo, da spletna stran zagotavlja izboljšano funkcionalnost in personalizacijo. 
                  Lahko jih nastavimo mi ali zunanji ponudniki, katerih storitve smo dodali na naše strani.
                </p>
                
                <h3 className="text-xl font-medium mt-4 mb-2">Ciljni piškotki</h3>
                <p className="text-luxgray">
                  Te piškotke lahko na vaši napravi nastavijo naši oglaševalski partnerji. Ta podjetja jih lahko uporabljajo za izdelavo profila vaših interesov 
                  in za prikaz relevantnih oglasov na drugih spletnih mestih.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">3. Upravljanje piškotkov</h2>
                <p className="text-luxgray">
                  Večina spletnih brskalnikov omogoča nadzor nad večino piškotkov prek nastavitev brskalnika. 
                  Če želite omejiti ali blokirati vse piškotke, ki jih nastavljajo naše spletne strani, lahko to storite prek nastavitev vašega brskalnika.
                </p>
                <p className="text-luxgray mt-2">
                  Navodila za upravljanje piškotkov v najpogostejših brskalnikih:
                </p>
                <ul className="list-disc pl-6 mt-2 text-luxgray">
                  <li>Google Chrome: Nastavitve → Zasebnost in varnost → Piškotki in drugi podatki strani</li>
                  <li>Mozilla Firefox: Nastavitve → Zasebnost in varnost → Piškotki in podatki strani</li>
                  <li>Safari: Nastavitve → Zasebnost → Piškotki in podatki spletnih mest</li>
                  <li>Microsoft Edge: Nastavitve → Piškotki in dovoljenja strani → Upravljanje in brisanje piškotkov in podatkov strani</li>
                </ul>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">4. Piškotki tretjih oseb</h2>
                <p className="text-luxgray">
                  Na naši spletni strani so lahko tudi piškotki tretjih oseb, ki jih nastavijo storitve, ki se pojavljajo na naših straneh. 
                  Ne moremo dostopati do ali nadzorovati teh piškotkov, saj jih nadzorujejo tretje osebe.
                </p>
                <p className="text-luxgray mt-2">
                  Med te lahko spadajo:
                </p>
                <ul className="list-disc pl-6 mt-2 text-luxgray">
                  <li>Google Analytics (za analitiko)</li>
                  <li>Facebook (za sledenje konverzijam in retargeting)</li>
                  <li>YouTube (za prikaz videov)</li>
                </ul>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">5. Spremembe politike piškotkov</h2>
                <p className="text-luxgray">
                  To politiko piškotkov lahko občasno posodobimo. Vse spremembe bodo objavljene na tej strani.
                </p>
                <p className="text-luxgray mt-2">
                  Ta politika piškotkov je bila nazadnje posodobljena 1.1.2023.
                </p>
              </section>
              
              <section>
                <h2 className="text-2xl font-medium mb-4">6. Kontakt</h2>
                <p className="text-luxgray">
                  Če imate kakršnakoli vprašanja o naši politiki piškotkov, nas kontaktirajte na info@luxdecor.si ali +386 31 467 272.
                </p>
              </section>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Piskotki;